(function(){
  const ROOT='.m6pr';
  const RADIO='input[type="radio"][name^="options["]';
  const FORM='form[action*="/cart/add"]';
  const touched=new WeakSet();

  function groups(radios){
    const m=new Map();
    radios.forEach(r=>{if(!m.has(r.name))m.set(r.name,[]);m.get(r.name).push(r)});
    return Array.from(m.values());
  }
  function setReady(root){
    const form=root.querySelector(FORM); if(!form)return;
    const radios=Array.from(root.querySelectorAll(RADIO));
    if(!radios.length){form.classList.remove('d27-ready');return;}
    const ok=groups(radios).every(g=>g.some(r=>r.checked));
    form.classList.toggle('d27-ready',ok);
  }
  function clearInitial(root){
    const form=root.querySelector(FORM); if(!form)return;
    const radios=Array.from(root.querySelectorAll(RADIO)); if(!radios.length)return;
    radios.forEach(r=>{r.checked=false;r.removeAttribute('checked')});
    form.classList.remove('d27-ready');
    root.dataset.d27InitialCleared='1';
  }
  function boot(root){
    if(!root || touched.has(root))return;
    const form=root.querySelector(FORM), radios=Array.from(root.querySelectorAll(RADIO));
    if(!form || !radios.length)return;
    touched.add(root);
    clearInitial(root);
  }
  function bootAll(scope){(scope||document).querySelectorAll(ROOT).forEach(boot)}

  /* Capture before native theme handlers. Clicking an already-selected option means unselect. */
  document.addEventListener('click',function(e){
    const label=e.target.closest(ROOT+' ul.check.box label'); if(!label)return;
    const root=label.closest(ROOT); if(!root)return;
    const id=label.getAttribute('for'); if(!id)return;
    const r=root.querySelector('#'+CSS.escape(id)); if(!r || !r.matches(RADIO) || r.disabled || r.classList.contains('disabled'))return;
    if(r.checked){
      e.preventDefault(); e.stopImmediatePropagation();
      r.checked=false; r.removeAttribute('checked');
      r.dispatchEvent(new Event('change',{bubbles:true}));
      setReady(root);
    } else {
      setTimeout(()=>setReady(root),0);
    }
  },true);
  document.addEventListener('change',function(e){
    if(!e.target.matches(RADIO))return;
    const root=e.target.closest(ROOT); if(root)setTimeout(()=>setReady(root),0);
  },true);

  /* Theme can AJAX-replace product markup after variant changes. Re-bind and clear only new roots. */
  const observer=new MutationObserver(ms=>{
    ms.forEach(m=>m.addedNodes.forEach(n=>{
      if(n.nodeType!==1)return;
      if(n.matches&&n.matches(ROOT))boot(n);
      if(n.querySelectorAll)bootAll(n);
    }));
  });
  function start(){bootAll(document);observer.observe(document.body,{childList:true,subtree:true})}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
  document.addEventListener('shopify:section:load',e=>bootAll(e.target));
})();
